"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _context = require("../../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex: none;\n  z-index: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: ", ";\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var zIndexes = {
  overlayBackdrop: 50,
  overlay: 51
};
var keyCodes = {
  esc: 27
};

var Overlay =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props) {
    var _this;

    _classCallCheck(this, Overlay);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Overlay).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this._renderOverlay();
    });

    _defineProperty(_assertThisInitialized(_this), "_renderOverlay", function () {
      if (_reactDom["default"].unstable_renderSubtreeIntoContainer && !_reactDom["default"].createPortal) {
        var _this$props = _this.props,
            open = _this$props.open,
            children = _this$props.children;
        var content = null;

        if (open) {
          content = _react["default"].createElement(Overlay.Backdrop, {
            onMouseDown: _this.handleMouseDown
          }, _react["default"].createElement(Overlay.Element, {
            innerRef: function innerRef(el) {
              return _this.contentElement = el;
            }
          }, children));
        }

        _reactDom["default"].unstable_renderSubtreeIntoContainer(_assertThisInitialized(_this), _react["default"].createElement("div", null, content), _this.mountElement);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (evt) {
      var _this$props2 = _this.props,
          closeOnBackdropClick = _this$props2.closeOnBackdropClick,
          open = _this$props2.open,
          onClose = _this$props2.onClose;
      var clickWasOnBackdrop = _this.contentElement && !_this.contentElement.contains(evt.target);

      if (open && closeOnBackdropClick && clickWasOnBackdrop) {
        onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentKeyDown", function (evt) {
      var _this$props3 = _this.props,
          closeOnEscape = _this$props3.closeOnEscape,
          open = _this$props3.open,
          onClose = _this$props3.onClose;
      var escapeWasPressed = evt.which === keyCodes.esc;

      if (open && closeOnEscape && escapeWasPressed) {
        onClose();
      }
    });

    _this.state = {
      hasBeenMounted: false
    };
    _this.mountElement = document.createElement('div');
    _this.contentElement = null;
    return _this;
  }

  _createClass(Overlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.appendChild(this.mountElement);
      document.addEventListener('keydown', this.handleDocumentKeyDown);
      this.setState({
        hasBeenMounted: true
      });

      this._renderOverlay();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _reactDom["default"].unmountComponentAtNode(this.mountElement);

      if (this.mountElement.parentNode) {
        this.mountElement.parentNode.removeChild(this.mountElement);
      }

      document.removeEventListener('keydown', this.handleDocumentKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          open = _this$props4.open,
          children = _this$props4.children;
      if (!this.state.hasBeenMounted) return null;
      var content = null;

      if (open) {
        content = _react["default"].createElement(Overlay.Backdrop, {
          onMouseDown: this.handleMouseDown
        }, _react["default"].createElement(Overlay.Element, {
          innerRef: function innerRef(el) {
            return _this2.contentElement = el;
          }
        }, children));
      }

      if (_reactDom["default"].createPortal) {
        return _reactDom["default"].createPortal(content, this.mountElement);
      } else {
        return null;
      }
    }
  }]);

  return Overlay;
}(_react["default"].Component);

Overlay.Backdrop = _styledComponents["default"].div(_templateObject(), zIndexes.overlayBackdrop, function (props) {
  return props.backdropShade === 'dark' ? "rgba(0, 0, 0, 0.4)" : "rgba(31, 37, 50, 0.8)";
});
Overlay.Element = _styledComponents["default"].div(_templateObject2(), zIndexes.overlay);
Overlay.propTypes = {
  closeOnBackdropClick: _propTypes["default"].bool.isRequired,
  closeOnEscape: _propTypes["default"].bool.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  open: _propTypes["default"].bool.isRequired,
  backdropShade: _propTypes["default"].oneOf(['light', 'dark'])
};
Overlay.defaultProps = {
  closeOnBackdropClick: true,
  closeOnEscape: true,
  open: false,
  backdropShade: 'light'
};
Overlay.displayName = 'Overlay';

var _default = (0, _context.withVersion)(Overlay);

exports["default"] = _default;